module.exports = __webpack_public_path__ + "img/partner-4.e1ecb58c.png";